import React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const headerVariants = cva('flex flex-col gap-0.5', {
  variants: {
    variant: {
      default: 'mb-6',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const ModalHeader = ({ children, className, variant, ...props }) => {
  return (
    <div className={cn(headerVariants({ variant }), className)} {...props}>
      {children}
    </div>
  );
};

export { ModalHeader, headerVariants };
